import React, { createContext, useContext } from 'react';

import { type FeatureFlagList } from './index';

export type FlagOverrides = Partial<FeatureFlagList>;

type FeatureFlagOverridesContextProps = {
	flagOverrides: FlagOverrides;
};

const FeatureFlagOverridesContext = createContext<FeatureFlagOverridesContextProps>({
	flagOverrides: {},
});

export const useFeatureFlagOverrides = () => {
	const { flagOverrides } = useContext(FeatureFlagOverridesContext);

	return flagOverrides;
};

type FeatureFlagOverrideProps = {
	flagOverrides: FlagOverrides;
	children: React.ReactNode;
};

/**
 * __Feature flag override__
 *
 * Allows overriding feature flags, limited to a subtree of the application.
 */
export const FeatureFlagOverrides = ({ flagOverrides, children }: FeatureFlagOverrideProps) => {
	return (
		<FeatureFlagOverridesContext.Provider
			value={{
				flagOverrides,
			}}
		>
			{children}
		</FeatureFlagOverridesContext.Provider>
	);
};
